export default "__VITE_ASSET__DDB6QIy9__"